<template>
  <v-card class="appViewWrap">
    <v-card-title v-if="title">
      {{ title }}
    </v-card-title>
    <v-card-subtitle v-if="$slots.header" class="py-4">
      <slot name="header" />
    </v-card-subtitle>
    <v-divider v-if="showDivider" />
    <v-card-text v-if="$slots['main-header']">
      <slot name="main-header" />
    </v-card-text>
    <slot />

    <v-divider v-if="showDivider" />

    <v-card v-if="$slots.footer">
      <slot name="footer" />
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: 'ViewS',
  props: {
    title: {
      type: String,
      default: '',
    },
    showDivider: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return {}
  },
}
</script>

<style scoped lang='scss'>
.appViewWrap {
  min-height: calc(100vh - 90px);
}
</style>
